// extracted by mini-css-extract-plugin
export var cartIcon = "_od-0";
export var cartIconContainer = "_od-1";